import { render, staticRenderFns } from "./ActiveDealsWrapper.vue?vue&type=template&id=64948f58&scoped=true&"
import script from "./ActiveDealsWrapper.vue?vue&type=script&lang=js&"
export * from "./ActiveDealsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ActiveDealsWrapper.vue?vue&type=style&index=0&id=64948f58&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64948f58",
  null
  
)

export default component.exports